import React, { createContext, useState } from "react";

export const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
    const [phoneNumber, setPhoneNumber] = useState("Test de numéro de téléphone");
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [cardBankNumber, setCardBankNumber] = useState();
    const [expirationDate, setExpirationDate]= useState();
    const [cvv, setCvv] = useState();
    return (
        <PaymentContext.Provider value={{phoneNumber, setPhoneNumber, paymentMethods, setPaymentMethods, cardBankNumber, setCardBankNumber, expirationDate, setExpirationDate, cvv, setCvv}}>
            {children}
        </PaymentContext.Provider>
    )
}